export default __webpack_public_path__ + "static/media/logo.a1ac5da2.png";